const setSelectedWindowDirectionType = (state, action) => {
  state.windowDirectionType = action.payload;
};

export default {
  setSelectedWindowDirectionType,
};
